interface CacheEntry {
  data: any[];
  timestamp: number;
}

const store = new Map<string, CacheEntry>();

export function getFromMemory(key: string): CacheEntry | null {
  return store.get(key) || null;
}

export function setInMemory(key: string, data: any[]): void {
  store.set(key, { data, timestamp: Date.now() });
}

export function clearMemory(key: string): void {
  store.delete(key);
}

export function clearAllMemory(): void {
  store.clear();
}

export function getAllMemoryKeys(): string[] {
  return Array.from(store.keys());
}
